import { Routes } from '@angular/router';
import { AuthGuardService } from '../modules/auth/services/auth-guard.service';
import { Permissions } from '../modules/auth/permissions/permissions';
import { DashboardComponent } from '../modules/dashboard/components/pages/dashboard/dashboard.component';
import { ReportsPageComponent } from '../modules/reports/components/pages/reports-page/reports-page.component';
import { ProductsPageComponent } from '../modules/products/components/pages/products-page/products-page.component';
import { AddProductPageComponent } from '../modules/products/components/pages/add-product-page/add-product-page.component';
import { ProductDetailsComponent } from '../modules/products/components/pages/product-details/product-details.component';
import { EditProductComponent } from '../modules/products/components/pages/edit-product/edit-product.component';
import { OrdersPageComponent } from '../modules/orders/components/pages/orders-page/orders-page.component';
import { OrderDetailsPageComponent } from '../modules/orders/components/pages/order-details-page/order-details-page.component';
import { UserManagementPageComponent } from '../modules/users-management/components/pages/user-management-page/user-management-page.component';
import { UserDetailsPageComponent } from '../modules/users-management/components/pages/user-details-page/user-details-page.component';
import { StaffFormPageComponent } from '../modules/users-management/components/pages/staff-form-page/staff-form-page.component';
import { ReviewPageComponent } from '../modules/reviews/components/pages/review-page/review-page.component';
import { SettingsComponent } from '../modules/settings/components/pages/settings/settings.component';
import { DeliveryOrdersComponent } from '../modules/orders/components/pages/delivery-orders/delivery-orders.component';
import { WalletComponent } from '../modules/wallet/components/pages/wallet/wallet.component';



export const vendorRoutes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    // {
    //     path: 'reports',
    //     component: ReportsPageComponent,
    //     canActivate: [AuthGuardService],
    //     data: { permission: [Permissions.IS_VENDOR] }
    // },
    {
        path: 'products',
        component: ProductsPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'products/new',
        component: AddProductPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'products/:id',
        component: ProductDetailsComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'products/:id/edit',
        component: EditProductComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'orders',
        component: OrdersPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'delivery-orders',
        component: DeliveryOrdersComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'orders/:id',
        component: OrderDetailsPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'users',
        component: UserManagementPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'users/new',
        component: StaffFormPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR], requiredStaffRoles: ['owner'] }
    },
    {
        path: 'users/:id',
        component: UserDetailsPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'users/:id/edit',
        component: StaffFormPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR], requiredStaffRoles: ['owner'] }
    },
    {
        path: 'reviews',
        component: ReviewPageComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
    {
        path: 'wallet',
        component: WalletComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR] }
    },
]
